import React from "react";
import logo from "../assets/images/logo.png";
import hamburger from "../assets/icon/hamburger.svg";

const nav = [
  {
    title: "Home",
    href: "home",
  },
  {
    title: "About",
    href: "about",
  },
  {
    title: "Services",
    href: "services",
  },
  {
    title: "Contact",
    href: "contact",
  },
];

const NavBar = ({ open, setOpen }) => {
  const renderedNav = nav.map(({ title, href }) => {
    return (
      <a
        href={`#${href}`}
        className="font-nunitoSans xl:px-3 font-semibold block text-base"
        key={title}
      >
        {title}
      </a>
    );
  });

  const isOpen = open ? "" : "hidden";

  return (
    <div className="w-full xl:flex xl:justify-between bg-gray-100 shadow-md px-4 pt-4 pb-2 sticky xl:static xl:bg-gray-200 top-0 z-10">
      <div className="flex justify-between">
        <div>
          <a href="#home">
            <img src={logo} alt="Logo" className="w-8 xl:mt-2" />
          </a>
        </div>
        <div>
          <button type="button" onClick={setOpen}>
            <img src={hamburger} alt="Hamburger" className="w-6 xl:hidden" />
          </button>
        </div>
      </div>
      <div className={`my-2 xl:block xl:flex ${isOpen}`}>{renderedNav}</div>
    </div>
  );
};

export default NavBar;
